import React, { useState } from "react";
import { toast } from "sonner";
import { Luggage } from "lucide-react";
import { api } from "@/lib/api";
import { recargarPlanes } from "@/lib/ocio";

// Propone unir dos planes en un viaje; solo se une si el usuario lo confirma.
export const SugerenciaViaje = ({ s }) => {
  const [ocupado, setOcupado] = useState(false);
  const responder = async (unir) => {
    setOcupado(true);
    try {
      await api.put("/ocio/viaje", { plan_ids: [s.a.id, s.b.id], unir });
      await recargarPlanes();
      toast.success(unir ? "Planes unidos en un mismo viaje" : "De acuerdo, no se unirán");
    } catch { toast.error("No se pudo guardar."); }
    setOcupado(false);
  };
  return (
    <div className="bg-white border-2 border-[#C9D8CF] rounded-2xl p-4 space-y-3" data-testid="ocio-sugerencia-viaje">
      <p className="font-heading text-lg font-bold text-[#1C2421] flex items-center gap-2"><Luggage size={20} className="text-[#3A6B56]" /> ¿Son del mismo viaje?</p>
      <p className="text-base text-[#4A5550]">«{s.a.nombre}» y «{s.b.nombre}» son el mismo día y los dos mencionan {s.ciudad}. Si los unes, ese día verás un resumen con el orden del viaje.</p>
      <div className="flex flex-wrap gap-2">
        <button data-testid="ocio-sugerencia-viaje-si" disabled={ocupado} onClick={() => responder(true)} className="min-h-[48px] px-4 rounded-xl bg-[#3A6B56] text-white font-semibold">Sí, son del mismo viaje</button>
        <button data-testid="ocio-sugerencia-viaje-no" disabled={ocupado} onClick={() => responder(false)} className="min-h-[48px] px-4 rounded-xl border border-[#E5DFD5] text-[#1C2421] font-semibold">No</button>
      </div>
    </div>
  );
};
